// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import DashboardIconInput from 'components/inputs/DashboardIconInput';
import TextInput from 'components/inputs/TextInput';
import Button from 'components/common/Button';
import Form from 'components/common/Form';
import FormItem from 'components/common/FormItem';
import DashboardTypeInput from 'components/inputs/DashboardTypeInput';

class CustomDashboardForm extends React.PureComponent {
  state = {
    dashboardId: this.props.dashboard && this.props.dashboard.dashboardId,
    name: this.props.dashboard && this.props.dashboard.name,
    embedUrl: this.props.dashboard && this.props.dashboard.embedUrl,
    icon: this.props.dashboard && this.props.dashboard.icon,
    groupId: this.props.dashboard && this.props.dashboard.groupId,
    filterType: this.props.dashboard && this.props.dashboard.filterType,
  };

  onChange = newValue => {
    this.setState(newValue);
  };

  onSubmit = () => {
    console.log(this.state);
    this.props.handleSubmit(this.state);
  };

  render() {
    return (
      <Form>
        <FormItem label="dashboardId">
          <TextInput value={this.state.dashboardId} onChange={dashboardId => this.onChange({ dashboardId })} />
        </FormItem>
        <FormItem label="name">
          <TextInput value={this.state.name} onChange={name => this.onChange({ name })} />
        </FormItem>
        <FormItem label="groupId">
          <TextInput value={this.state.groupId} onChange={groupId => this.onChange({ groupId })} />
        </FormItem>
        <FormItem label="embedUrl">
          <TextInput value={this.state.embedUrl} onChange={embedUrl => this.onChange({ embedUrl })} />
        </FormItem>
        <FormItem label="icon">
          <DashboardIconInput value={this.state.icon} onChange={icon => this.onChange({ icon })} />
        </FormItem>
        <FormItem label="Filter Type">
          <DashboardTypeInput value={this.state.filterType} onChange={filterType => this.onChange({ filterType })} />
        </FormItem>
        <FormItem>
          <Button onClick={this.onSubmit}>{this.props.buttonLabel}</Button>
        </FormItem>
      </Form>
    );
  }
}

CustomDashboardForm.defaultProps = {
  buttonLabel: 'Submit',
};

export default CustomDashboardForm;



// WEBPACK FOOTER //
// ./src/components/forms/CustomDashboardForm/index.js